import type React from "react";
import { EventCreateContent } from "@/features/create-event/components/EventCreateContent";
import type { EventFormData } from "@/features/study-group-events/type";
import type { EventApiResponse } from "@/lib/humhub-api/types";
import { buildInitialFormDataFromApiEvent } from "@/lib/utils/event/form-initializer";

interface EventDuplicateContentProps {
  eventData: EventApiResponse;
  onSuccess: () => void;
  onCompletionStateChange?: (completed: boolean) => void;
}

export const EventDuplicateContent: React.FC<EventDuplicateContentProps> = ({
  eventData,
  onSuccess,
  onCompletionStateChange,
}) => {
  const initialFormData: EventFormData = buildInitialFormDataFromApiEvent(
    eventData,
    {
      preserveEventTimezoneDateTime: true,
    },
  );

  return (
    <div className="flex h-full flex-col">
      {/* イベント作成フォーム */}
      <div className="flex-1 overflow-y-auto">
        <EventCreateContent
          initialFormData={initialFormData}
          onSuccess={onSuccess}
          onCompletionStateChange={onCompletionStateChange}
        />
      </div>
    </div>
  );
};
